import { useEffect, useState } from "react";
import MovimentacaoEstoqueController from "../controllers/MovimentacaoEstoqueController";
import * as Icon from '@mui/icons-material/';
import { formatDate } from "../shared/utils/helpers/numbers";
import { ButtonMenu } from "../shared/components/ButtonMenu";
import { toast } from "react-toastify";
import { Column } from "../pages/Components/Table/Types";

interface Row {
    BtnEditar?: JSX.Element;
    BtnExcluir?: JSX.Element;
    pme_id: number;
    proCodigo: number;
    codigo: string;
    prod_descricao: string;
    pme_descricao: string;
    pme_tipo: string;
    pme_origem: string;
    pme_idOrigem: number;
    pme_quantidade: number;
    pme_datainc: string;
}

const useMovimentacaoEstoquePesquisar = () => {

    const [loading, setLoading] = useState<boolean>(false);

    const seteDiasAtras = new Date();
    seteDiasAtras.setDate(seteDiasAtras.getDate() - 7);

    const initialValues = {
        dataInicial: seteDiasAtras.toISOString().split('T')[0],
        dataFinal: new Date().toISOString().split('T')[0],
        codProduto: '',
        prodes: '',
    };

    const tableColumns: Column[] = ([
        { id: 'pme_id', label: 'pme_id', minWidth: 0, maxWidth: undefined, align: 'center', hidden: true },
        { id: 'proCodigo', label: 'proCodigo', minWidth: 0, maxWidth: undefined, align: 'center', hidden: true },
        { id: 'codigo', label: 'Código', minWidth: 0, maxWidth: undefined, align: 'center' },
        { id: 'prod_descricao', label: 'Produto', minWidth: 0, maxWidth: undefined },
        { id: 'pme_descricao', label: 'Descrição', minWidth: 0, maxWidth: undefined },
        { id: 'pme_tipo', label: 'Tipo', minWidth: 0, maxWidth: undefined },
        { id: 'pme_origem', label: 'Origem', minWidth: 0, maxWidth: undefined, hidden: true },
        { id: 'pme_idOrigem', label: 'idOrigem', minWidth: 0, maxWidth: undefined, hidden: true },
        { id: 'pme_quantidade', label: 'Quantidade', minWidth: 0, maxWidth: undefined, align: 'center' },
        { id: 'pme_datainc', label: 'Data', minWidth: 0, maxWidth: undefined, align: 'center' },
        { id: 'BtnMenu', label: '', width: 60, minWidth: 0, maxWidth: undefined, align: 'right' },
    ]);

    const [tableRows, setTableRows] = useState<Row[]>([]);

    const fields = [
        { name: 'dataInicial', type: 'date', label: 'Data Início', col: 2 },
        { name: 'dataFinal', type: 'date', label: 'Data Final', col: 2 },
        { name: 'codProduto', type: 'text', label: 'Código' },
        { name: 'prodes', type: 'text', label: 'Produto' },
        { type: 'submit', icon: (<Icon.Search style={{ fontSize: '28px' }} />) },
    ]

    const handleSubmit = async (values: any) => {
        setLoading(true)

        const DataRows: any = [];
        const Response: any = await MovimentacaoEstoqueController.Listar(values);

        if (Response.StatusCode === 200 && Response?.Data?.length > 0) {
            Response.Data.map((item: Row) => {
                DataRows.push({
                    pme_id: item.pme_id,
                    proCodigo: item.proCodigo,
                    codigo: item.codigo,
                    prod_descricao: item.prod_descricao,
                    pme_descricao: item.pme_descricao,
                    pme_tipo: item.pme_tipo,
                    pme_origem: item.pme_origem,
                    pme_idOrigem: item.pme_idOrigem,
                    pme_quantidade: item.pme_quantidade,
                    pme_datainc: formatDate(item.pme_datainc),
                    BtnMenu: (
                        <ButtonMenu
                            items={[
                                //{ onClick: () => handleEditItem(item), menu: 'Editar' },
                                { onClick: () => handleDeleteItem(item.pme_id), menu: 'Excluir', confirmar: `Excluir a movimentação "${item.pme_descricao ?? ''}"? Esta ação não pode ser desfeita.` },
                            ]}
                        />
                    ),
                });

                setTableRows(DataRows);
            });
        } else if (Response.StatusCode === 204 && Response?.Data?.length === 0) {
            toast('Não há registros cadastrados.', {
                type: 'error',
            });
            setTableRows([]);
        } else {
            toast('Ocorreu um erro inesperado.', {
                type: 'error',
            });
        }

        setLoading(false);
    };

    const handleDeleteItem = async (id: number) => {
        toast('Ação desabilitada no momento.', {
            type: 'info',
        });
    };

    useEffect(() => {
        handleSubmit(initialValues);
    }, []);

    return {
        loading,
        initialValues,
        tableColumns,
        tableRows,
        fields,
        handleSubmit,
    };
}

export default useMovimentacaoEstoquePesquisar;